import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import StyledButton from 'components/Button';
import Card from 'components/Card';
import { BookingSummaryContainer } from './style';
import { useRecoilValue, useRecoilState } from 'recoil';
import { selectedRooms } from 'states/CheckOutStates/atoms';
import {
  dateRangeState,
  guestQuantityState,
  roomQuantityState,
} from 'states/SearchBarStates/atoms';
import { addOnOptionsState } from "states/OptionStates/atoms";
import { useGetBookingAddOns } from 'customHooks/useGetBookingAddOns';
import moment from 'moment';
// import { RedCloseIcon } from 'assets/icons';
import { EditIcon } from 'assets/icons';

const BookingSummary: FC = () => {

  const history = useHistory()

  const [persistSelectedRooms] = useRecoilState(selectedRooms);
  const [guestQuantity] = useRecoilState(guestQuantityState);
  const [roomQuantity] = useRecoilState(roomQuantityState);
  const dateRange = useRecoilValue(dateRangeState);
  // customer selected addOns
  const [addOnOptions] = useRecoilState(addOnOptionsState);
  // all addOns query from server
  const bookingAddOns = useGetBookingAddOns()
  

  const handleNext = () => {
    history.push('/check-out');
  }

  const addOnOptionsArray =  bookingAddOns.map((addOn) => {
    if(addOnOptions.includes(addOn.addOnId)) {
      return (
        <div className="priceDetails" key={addOn.addOnId}>
          <span className="text">{addOn.label?.toUpperCase()}</span>
          <span className="price">{
            `CAD ${addOn.pricePerNight.toFixed(2)}${addOn.label==='Breakfast'? ' / day':
              addOn.label==='Parking'? ' / 24 hrs': ''}`
          }</span>
        </div>
      )
    }
    return null
  })

  return (
    <BookingSummaryContainer>
      <Card padding='10px 20px'>
        <div className="title">
          <span className='text'>Book your stay with us</span>
          <span
            className='editTrip'
            onClick={() => {
              history.push(`/search?checkInDate=${dateRange[0]}&checkOutDate=${dateRange[1]}&guestQuantity=${guestQuantity}&roomQuantity=${roomQuantity}`);
            }}
          >
            <EditIcon className='editIcon'/>
            Edit trip
          </span>
        </div>
        <div className="bookingDates">
          <div className="text">DATES</div>
          <div className='checkInOutDates'>
            {moment(dateRange[0]).format('ddd, DD MMM')} -
            {moment(dateRange[1]).format('ddd, DD MMM')}
          </div>
        </div>
        <div className="guestOption">
          <span className="text">GUESTS</span>
          <span className="numbers">
            {guestQuantity}
          </span>
        </div>
        <div className="roomOption">
          <span className="text">ROOMS</span>
          <span className="numbers">
            {roomQuantity}
          </span>
        </div>
        <div className="booking">Your Booking: </div>
        <div className="priceDetails">
          <span className='text'>{persistSelectedRooms.name?.toUpperCase()}</span>
          <span className='price'>{` CAD ${persistSelectedRooms.pricePerNight?.toFixed(2)} / night`}</span>
        </div>
        <>{addOnOptionsArray}</>
        <div className="controls">
        <StyledButton
          className="nextButton"
          height="48px"
          margin='42px 0 10px 0'
          padding ="0 24px"
          fontSize={16}
          onClick={handleNext}
        >
          Next Step
        </StyledButton>
        </div>
      </Card>
    </BookingSummaryContainer>
  )
}

export default BookingSummary